import { isUnderConsentAge } from '../../utils/consent-age';
import type { AvatarColor } from '../../lib/avatar-colors';

/** One athlete as the parent is typing them, before there is an account. */
export interface AthleteDraft {
  /** Local only: these have no id until the server makes one. */
  key: string;
  name: string;
  surname: string;
  birth_date: string;
  avatar_color: AvatarColor | null;
  /**
   * The class they compete in, male or female — only where the form asks it
   * (correcting a child on /profile/athletes, and the guided sign-up, where it
   * is required); null is "not said".
   */
  gender?: 'male' | 'female' | null;
  /**
   * The turn picked on the guided sign-up, when the child's class is split
   * over two or more at the stage they are being entered in.
   */
  competition_round_id?: string | null;
}

export function emptyAthlete(): AthleteDraft {
  return {
    key: `athlete-${Math.random().toString(36).slice(2, 9)}`,
    name: '',
    surname: '',
    birth_date: '',
    avatar_color: null,
  };
}

/**
 * Whether there is enough here to open an account. The server has the last
 * word (WardCreation), including on the age: from 14 there is nobody to hold
 * an account for.
 */
export function athleteIsComplete(athlete: AthleteDraft): boolean {
  return (
    athlete.name.trim().length > 0 &&
    athlete.surname.trim().length > 0 &&
    isUnderConsentAge(athlete.birth_date)
  );
}
